export const DEFAULT_DIAMETER = 149;

const DEFAULT_STROKE_WIDTH = 14;
const DEFAULT_GRADIENT_X_ONE = 38.7939;
const DEFAULT_GRADIENT_Y_ONE = 24.9486;
const DEFAULT_GRADIENT_X_TWO = 99.8488;
const DEFAULT_GRADIENT_Y_TWO = 165.162;

const DEFAULT_DIAMETER_PERCENT = DEFAULT_DIAMETER / 100;
export const STROKE_WIDTH_PERCENTAGE =
  DEFAULT_STROKE_WIDTH / DEFAULT_DIAMETER_PERCENT;
export const GRADIENT_X_ONE_PERCENTAGE =
  DEFAULT_GRADIENT_X_ONE / DEFAULT_DIAMETER_PERCENT;
export const GRADIENT_Y_ONE_PERCENTAGE =
  DEFAULT_GRADIENT_Y_ONE / DEFAULT_DIAMETER_PERCENT;
export const GRADIENT_X_TWO_PERCENTAGE =
  DEFAULT_GRADIENT_X_TWO / DEFAULT_DIAMETER_PERCENT;
export const GRADIENT_Y_TWO_PERCENTAGE =
  DEFAULT_GRADIENT_Y_TWO / DEFAULT_DIAMETER_PERCENT;
